import React from "react";
import Slider from "react-slick";

export default function BannerSection({ data, onOpenPdf }) {
  const configuredSlides = data.slides || [data];
  const slides = configuredSlides.filter((slide) => slide.enabled !== false);

  if (!slides.length) {
    return null;
  }

  const settings = {
    arrows: false,
    autoplay: slides.length > 1,
    autoplaySpeed: 5000,
    dots: slides.length > 1,
    infinite: slides.length > 1,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: "ease-in-out",
    customPaging: (index) => (
      <button type="button" aria-label={`Go to hero slide ${index + 1}`}>
        <svg className="banner-progress-dot" viewBox="0 0 24 24" aria-hidden="true">
          <circle className="banner-progress-dot-track" cx="12" cy="12" r="9" />
          <circle className="banner-progress-dot-value" cx="12" cy="12" r="9" />
        </svg>
      </button>
    ),
  };

  return (
    <section className="banner-slider-section">
      <Slider className="banner-slider" {...settings}>
        {slides.map((slide, index) => (
          <div key={`${slide.title}-${index}`}>
            <article
              className="banner-section"
              style={{
                "--banner-desktop-image": `url("${slide.image}")`,
                "--banner-mobile-image": `url("${slide.mobileImage || slide.image}")`,
              }}
            >
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-8 col-md-8">
                    <div className="banner-content-wrapper">
                      <p className="subtitle">{slide.eyebrow}</p>
                      <h2 className="heading">
                        {slide.title} <span>{slide.highlight}</span>
                        {slide.punctuation ?? "."}
                      </h2>
                      <p>{slide.description}</p>
                      {slide.cta?.label && slide.cta?.pdf && (
                        <button
                          type="button"
                          className="default-btn banner-pdf-cta white-font"
                          onClick={() => onOpenPdf?.(slide.cta)}
                        >
                          {slide.cta.label}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        ))}
      </Slider>
      <h1 className="visually-hidden">{data.pageTitle || slides[0]?.title}</h1>
    </section>
  );
}
